import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class TripService extends BaseService {

	constructor() {	
		super();
	}
	
	async getTrips(tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/trips/tractors/' + tractorId +  params);		
		return data;		
	}
	
	exportTrips(tractorId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/trips/tractors/' + tractorId + '/export' + params);		
	};	
		
	async getTrip(recordId) {
		var data = await this.makeGETRequest('/api/resource/trips/' + recordId);		
		return data;		
	}
	
	async saveTrip(trip, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/trips/' + trip.recordId, trip);
		} else {
			saved = await this.makePOSTRequest('/api/resource/trips', trip);
		}
		return saved;		
	}
	
	async transferTripsToGPS(request) {	
		var result = await this.makePOSTRequest('/api/resource/trips/transfer', request);
		return result;
	}		
	
	async reReferenceTrip(reRefRequest) {	
		var result = await this.makePUTRequest('/api/resource/trips/re-reference', reRefRequest);
		return result;
	}		
	
	async timeshiftTrip(timeShiftRequest) {	
		var result = await this.makePUTRequest('/api/resource/trips/timeshift', timeShiftRequest);
		return result;
	}
	
	async deleteTrips(request) {
		var data = await this.makeDELETERequest('/api/resource/trips', request);		
		return data;		
	}
	
	async deleteBulkTrips(bulkRequest) {
		var data = await this.makeDELETERequest('/api/resource/trips/bulk',  bulkRequest);		
		return data;		
	}	

	// Stops
	
	async getTripStops(tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/trip-stops/tractors/' + tractorId +  params);		
		return data;		
	}
	
	exportTripStops(tractorId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/trip-stops/tractors/' + tractorId + '/export' + params);		
	};	
		
	async getTripStop(stopId) {
		var data = await this.makeGETRequest('/api/resource/trip-stops/' + encodeURIComponent(stopId));		
		return data;		
	}
	
	async saveTripStop(stop, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/trip-stops/' + encodeURIComponent(stop.stopId), stop);
		} else {
			saved = await this.makePOSTRequest('/api/resource/trip-stops', stop);
		}
		return saved;		
	}
	
	async transferStopsToGPS(request) {	
		var result = await this.makePOSTRequest('/api/resource/trip-stops/transfer', request);
		return result;
	}	
	
	async deleteTripStops(request) {
		var data = await this.makeDELETERequest('/api/resource/trip-stops', request);		
		return data;		
	}	
		
}
